module.exports = __webpack_public_path__ + "img/cea-logo.a9da56a9.png";